import { combineReducers } from '@reduxjs/toolkit';
import { configReducer } from './config/reducer';
import { envReducer } from './env/reducer';
import { languageReducer } from './language/reducer';
import { modalReducer } from './modal/reducer';
import { navReducer } from './nav/reducer';
import { registerReducer } from './register/reducer';
import { scrollReducer } from './scrollPage/reducer';
const reducerMap = {
    config: configReducer,
    nav: navReducer,
    modal: modalReducer,
    env: envReducer,
    register: registerReducer,
    scrollPage: scrollReducer,
    lang: languageReducer,
};
export const rootReducer = combineReducers(reducerMap);
